import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  settingData: {},
  pageFlag: 'create'
}

export const settingSlice = createSlice({
  name: 'setting',
  initialState,
  reducers: {
    // 自动生成 action creator 和 reducer
    setSettingDataAction: (state, action) => {
      state.settingData = action.payload
    },
    setSettingPageFlagAction: (state, action) => {
      state.pageFlag = action.payload
    },
  }
})

// 自动生成的 action creators
export const { setSettingDataAction, setSettingPageFlagAction } = settingSlice.actions

// Selectors
export const selectSettingData = (state) => state.setting.settingData
export const selectSettingPageFlag = (state) => state.setting.pageFlag

// Reducer
export default settingSlice.reducer